import { type FC } from "react";
import { useDetectWindowSizeInfo } from "@userFrontend/hooks/useDetectWindowSize";
import { type ColorSetting, type Name } from "@userFrontend/components/PieChart/colors";
import { PieChart as PieChartComponent } from "@userFrontend/components/PieChart";

type Props = {
  items: {
    label: string;
    value: number;
    name: Name;
  }[];
  colorSetting: ColorSetting;
};

export const PieChart: FC<Props> = ({ items, colorSetting }) => {
  const { isSP } = useDetectWindowSizeInfo();

  return <PieChartComponent isSP={isSP} items={items} colorSetting={colorSetting} />;
};
